'use strict';

function FunctionsExecutor() {
}

FunctionsExecutor.prototype = $.extend({}, {
  constructor: 'FunctionsExecutor',

  execute: function execute(actions, callback) {
    var _this = this;

    if (actions.length === 0) {
      return callback();
    }

    var action = actions.shift();
    var object = action.object;
    var fn = action.fn;

    object[fn](function () {
      _this.execute(actions, callback);
    });

    return _this;
  },
});
